export default __webpack_public_path__ + "static/media/defiPlatformBanner2.1c2f578d.png";